import SetupLayout from './SetupLayout';

export default SetupLayout;
